

import React, { useState, useEffect, useCallback } from 'react';
import Rodape from '../../components/Rodape';
import Navegador from '../../components/NavBar';
import capa_sobre from '../../assets/imgs/capa_sobre.jpg';
import capa_banner_sobre from '../../assets/imgs/capa_banner_sobre.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Grid from '@material-ui/core/Grid';
import visao from '../../assets/imgs/visao.png';
import missao from '../../assets/imgs/missao.png';
import filosofia from '../../assets/imgs/filosofia.png';
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import capa1mobile from '../../assets/imgs/capa1mobile.png';
import area_atuacao from '../../assets/imgs/area_atuacao.png';
import Typography from '@material-ui/core/Typography';
import { useDropzone } from 'react-dropzone';
import api from '../../services/api';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

import './styles.scss';

import globalConfig from '../../configs/globalConfigs';
import axios from 'axios';
import reCAPTCHA from "react-google-recaptcha"


import miniatura_pdf from '../../assets/imgs/miniatura_pdf.png';


const dropzoneStyles = {
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
};

const AutenticarDoc = () => {




    const [width, setWidth] = useState(0);


    function checkDimenssoes() {


        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;



        setWidth(largura)

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });



    useEffect(() => {



        checkDimenssoes();



    }, []);

    const [captchaVerified, setCaptchaVerified] = useState(false);

    const handleCaptchaVerify = (response) => {
        // Chamado quando o reCAPTCHA é verificado com sucesso
        setCaptchaVerified(true);
    };

    const [arquivoSelecionado1, setArquivoSelecionado1] = useState(null);


    const onDropArquivo1 = useCallback((acceptedFiles) => {
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf')) {
            alert('Apenas arquivos PDF são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setArquivoSelecionado1(acceptedFiles[0]);


    }, []);

    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });

    const [open, setOpen] = useState(false);
    const [mensagem, setMensagem] = useState("");

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setArquivoSelecionado1(null);
        setMensagem('');
    };

    

   async function autenticar() {
    if (!arquivoSelecionado1) {
        alert("Selecione um arquivo PDF para a consulta!");
        return null;
    }

    try {
        // Obter IP + localização (gratuito via ipwhois.io)
        const ipResponse = await axios.get("https://ipwhois.app/json/");
        const clientIP = ipResponse.data.ip;
        const latitude = ipResponse.data.latitude;
        const longitude = ipResponse.data.longitude;

        console.log("IP:", clientIP);
        console.log("Latitude:", latitude);
        console.log("Longitude:", longitude);

        console.log("cadastrar chamado");

        const formData = new FormData();
        formData.append("arquivos", arquivoSelecionado1);
        formData.append("ip", clientIP);
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);

        const responseCadastro = await api.post(
            "/v1/public/consultarautenticacao",
            formData
        );

        const cadastro_salvo = responseCadastro.data;
        if (cadastro_salvo) {
            let texto =
                "Sucesso!\n\nEste é um documento original emitido pelo Grupo Rosinetos!\n\nO documento é válido, caso ainda tenha dúvidas, contate-nós, abaixo especificamos nossos meios de contato";

            setMensagem(texto);
            handleOpen();
            setArquivoSelecionado1(null);
            setCaptchaVerified(false);
        } else {
            let texto =
                "Atenção!\n\nEste NÃO é um documento original emitido pelo Grupo Rosinetos!\n\nPedimos que entre em contato conosco por algum meio de contato especificado abaixo, não cumpra nenhum requisito deste documento, ele não é válido!";

            setMensagem(texto);
            handleOpen();
            setArquivoSelecionado1(null);
            setCaptchaVerified(false);
        }
    } catch (_err) {
        console.log("erro ao cadastrar: " + _err);
        alert("Erro de Conexão, tente novamente mais tarde");
        setCaptchaVerified(false);
    }
}

    return (
        <div >
            <div style={{
                backgroundImage: width > 1200 ? `url(${capa_sobre})` : `url(${capa1mobile})`,
                backgroundSize: "contain",
                width: '100%',
                height: '100%',
            }} >

                <Navegador sobre={'underline'} corFundo={'rgba(255,255,255,1)'} travado={width > 900 ? true : false} corTexto={'black'} />
            </div>



            <Grid item xs={12} container
                direction='row'
                alignContent='center'
                justifyContent='center'

                style={{ margin: 50 }} >



                <Grid item xs={6} container
                    direction='row'
                    alignContent='center'
                    justifyContent='center'
                >

                    <Grid item xs={12} container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{ paddingTop: 50 }}
                    >
                        <Typography variant="h4">
                            Validar Integridade de Arquivo
                        </Typography>
                    </Grid>


                    <Grid item xs={12} container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{ paddingTop: 50 }}

                    >
                        <Typography variant="h6">
                            Nesta página, você pode verificar a integridade de um arquivo PDF de um documento assinado no Grupo Rosinetos.
                        </Typography>
                    </Grid>


                    <Grid item xs={12} container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{ paddingTop: 50 }}
                    >
                        <Typography variant="h6">
                            Faça o upload do arquivo no espaço ao lado para verificar se ele foi gerado no Grupo Rosinetos.
                        </Typography>
                    </Grid>


                </Grid>

                <Grid item xs={6} container
                    direction='row'
                    alignContent='center'
                    justifyContent='center'
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        item xs={12}
                    >
                        {arquivoSelecionado1 ? (

                            <div
                                href={URL.createObjectURL(arquivoSelecionado1)}
                                onClick={() => window.open(URL.createObjectURL(arquivoSelecionado1), '_blank')}
                                onMouseOver={() => console.log('URL:', URL.createObjectURL(arquivoSelecionado1))}
                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '200px', height: '200px' }}>
                                <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf}></img>
                            </div>


                        ) : (
                            <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                <input {...getInputArquivoProps1()} />
                                <Typography align="center" variant="h6">
                                    Upload do arquivo
                                </Typography>
                            </div>
                        )}
                    </Grid>

                 

                   
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        item xs={12}
                        style={{ paddingTop: 30 }}

                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => autenticar()}
                        > Consultar  </Button>
                    </Grid>

                </Grid>

            </Grid>

            <div >
                <Rodape />
            </div>


            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Informação</DialogTitle>
                <DialogContent dividers>
                    <Grid
                        item xs={12}
                        container
                        direction='row'
                        justifyContent='center'
                        alignItens='center'
                        style={{ textAlign: 'center' }}
                    >
                        <Grid
                            item xs={12}
                            container
                            direction='row'
                            justifyContent='center'
                            alignItens='center'
                            style={{ textAlign: 'center' }}
                        >
                            <Typography component="div" style={{ whiteSpace: 'pre-line' }}>{mensagem}</Typography>
                        </Grid>
                        <Grid
                            item xs={12}
                            container
                            direction='row'
                            justifyContent='center'
                            alignItens='center'
                            style={{ textAlign: 'center', color: 'black' }}
                        >
                            <span style={{ fontSize: 14, color: 'white', paddingTop: 30, color: 'black' }}>

                                <img alt="{telefone}"
                                    style={{ weight: 20, height: 20 }}
                                    src={'https://www.certsan.com.br/wp-content/uploads/2020/05/icone-telefone-1.png'}
                                />
                                (91) 9 8897-5705
                                <br></br> <br></br>
                                <img alt="{telefone}"
                                    style={{ weight: 20, height: 20, color: 'black' }}
                                    src={'https://cdn-icons-png.flaticon.com/512/3670/3670051.png'}
                                />
                                <a
                                    style={{ fontSize: 14, textDecoration: 'underline', color: 'black' }}
                                    href="https://api.whatsapp.com/send?1=pt_BR&phone=551125897073">

                                    (91) 3033-7575</a>

                                <br></br> <br></br>
                                <img alt="{telefone}"
                                    style={{ weight: 20, height: 20 }}
                                    src={'https://cdn-icons-png.flaticon.com/512/2504/2504727.png'}
                                />
                                <a href={"mailto:contato@gruporosinetos.com"} style={{ fontSize: 14, color: 'black' }}> contato@gruporosinetos</a>
                            </span>
                        </Grid>
                    </Grid>

                </DialogContent>



                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

        </div >


    );
}

export default AutenticarDoc;

